var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-file" },
    [
      _c(
        "el-upload",
        {
          ref: "fileUpload",
          staticClass: "file-upload",
          attrs: {
            drag: "",
            headers: _vm.headers,
            data: _vm.uploadData,
            multiple: _vm.multiple,
            limit: _vm.limit,
            "show-file-list": _vm.showFile,
            "file-list": _vm.fileList,
            accept: _vm.accept,
            "before-upload": _vm.beforeUploadCallback,
            action: _vm.url,
            "on-remove": _vm.uploadRemove,
            "on-error": _vm.uploadError,
            "on-success": _vm.uploadSuccess,
            "on-progress": _vm.uploadProgress,
            "on-change": _vm.uploadChange
          }
        },
        [
          _c(
            "div",
            { staticClass: "content-box" },
            [
              !_vm.uploadFiles.length
                ? [
                    _vm._t("default", [
                      _c("div", { staticClass: "el-upload__text" }, [
                        _c("span", [_vm._v(_vm._s(_vm.uploadText))]),
                        _vm.accept || _vm.formatText
                          ? _c("span", { staticClass: "format-tip" }, [
                              _vm._v(
                                "（支持格式：" +
                                  _vm._s(
                                    _vm.formatText ? _vm.formatText : _vm.accept
                                  ) +
                                  "）"
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                : _c(
                    "ul",
                    { staticClass: "file-list" },
                    _vm._l(_vm.uploadFiles, function(item, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "file-li" },
                        [
                          _c("div", { staticClass: "li-content" }, [
                            _vm.getFileIcon(item.name) === "common"
                              ? _c("i", { staticClass: "el-icon-document" })
                              : _c("span", {
                                  staticClass: "file-icon",
                                  class: [_vm.getFileIcon(item.name) + "-icon"]
                                }),
                            _c("div", { staticClass: "text-box" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "file-name",
                                  attrs: { title: item.name }
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              item.hideProgress && item.status === "success"
                                ? _c("span", { staticClass: "status-text" }, [
                                    _vm._v("上传成功")
                                  ])
                                : _vm._e()
                            ]),
                            _c("i", {
                              staticClass: "el-icon-close delete-icon",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.removeFile(index)
                                }
                              }
                            })
                          ]),
                          !item.hideProgress
                            ? _c("el-progress", {
                                staticClass: "progress",
                                attrs: {
                                  "stroke-width": 2,
                                  "show-text": false,
                                  color:
                                    item.status === "fail"
                                      ? "#DB0011"
                                      : "#31A3EE",
                                  percentage: item.percentage
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }